module.exports = __webpack_public_path__ + "img/air_switc.fba874d4.png";